export interface RatingConfigState {
  ratingEnabled: boolean;
  ratingScale: number;
  ratingLabel: string;
}

interface Props {
  config: RatingConfigState;
  onChange: (updated: RatingConfigState) => void;
}

export default function RatingConfig({ config, onChange }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">
          Rating enabled
        </span>
        <button
          type="button"
          onClick={() =>
            onChange({ ...config, ratingEnabled: !config.ratingEnabled })
          }
          className={`relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
            config.ratingEnabled ? "bg-electrum-300" : "bg-gray-200"
          }`}
        >
          <span
            className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow transition duration-200 ease-in-out ${
              config.ratingEnabled ? "translate-x-4" : "translate-x-0"
            }`}
          />
        </button>
      </div>

      {config.ratingEnabled && (
        <>
          <div>
            <label className="block text-xs text-gray-500 mb-1">
              Rating scale (1–N)
            </label>
            <input
              type="number"
              min={2}
              max={10}
              value={config.ratingScale}
              onChange={(e) =>
                onChange({ ...config, ratingScale: Number(e.target.value) })
              }
              className="w-full rounded-lg border border-gray-300 px-3 py-1.5 text-sm focus:border-electrum-300 focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">
              Rating question label
            </label>
            <input
              type="text"
              value={config.ratingLabel}
              onChange={(e) =>
                onChange({ ...config, ratingLabel: e.target.value })
              }
              placeholder="e.g. How well did you sleep last night?"
              className="w-full rounded-lg border border-gray-300 px-3 py-1.5 text-sm focus:border-electrum-300 focus:outline-none"
            />
          </div>
        </>
      )}
    </div>
  );
}
